import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
export const useBoundingRect = ()=>{
    const ref = useRef(null);
    const [rect, setRect] = useState({
        top: 0,
        left: 0,
        width: 0,
        height: 0
    });
    const [addedEventListeners, setAddedEventListeners] = useState(false);
    const set = ()=>{
        if (ref && ref.current) {
            setRect(ref.current.getBoundingClientRect());
        }
    };
    useEffect(()=>{
        set();
        if (!addedEventListeners) {
            window.addEventListener("resize", set);
            window.addEventListener("scroll", set);
            window.addEventListener("onscroll", set);
            setAddedEventListeners(true);
        }
        return ()=>{
            window.removeEventListener("resize", set);
            window.removeEventListener("scroll", set);
            window.removeEventListener("onscroll", set);
        };
    }, []);
    return {
        rect,
        ref,
        recalculate: set
    };
};
